<template>
    <div>
    <span class="Maintitle"> 
    <h4><small class="text-muted">
             <i class="fas fa-envelope"></i> <strong> Contact Us : </strong> 
           
    </small></h4>  
    </span> 
    <!-- <span class="Maintitle">
    <i class="fas fa-clinic-medical"></i>
    <strong> Medical Supplies and Services Claims Application (MSSCS) </strong>
    </span> -->
    <Card>
      <CardBody>
           All General inquiries should be directed to:
        <div class="row mt-1">  
          <div class="col-12 col-lg-6">
            <TileCard>
              <template slot="header">Vaccine Portal.</template>
              <template slot="body">
                <address>
                  Ministry of Health, 2nd floor, 3475 Albert Street<br> Regina, Saskatchewan, Canada S4S 6X6<br>
                  <abbr title="Email">Email: </abbr> Janis Johnson at <b>Janis.Johnson@health.gov.sk.ca</b><br>
                  <abbr title="Fax">Fax</abbr>: 306 798-2022
                </address>
              </template>
            </TileCard>
          </div>
        </div>
       <div class="row mt-1">  
          <div class="col-12 col-lg-6">
            <TileCard>
              <template slot="header">Password Reset and Login Problems.</template>
              <template slot="body">
                <abbr title="CGI Help Desk">CGI Help Desk: </abbr> at <b>  1-800-667-6080 or 306-761-4286</b><br>
                
               
              </template>
            </TileCard>
          </div>
        </div>

      </CardBody>
        </Card>
</div>
</template>
<script>
import axios from 'axios'
import axiosauth from '@/axios-auth'
import Card from "@/Common/Card.vue";
import CardBody from "@/Common/CardBody.vue";
import TileNote from "@/Common/TileNote.vue";
import TileCard from "@/Common/TileCard.vue";
import { mapGetters } from 'vuex';
export default  {
     props:{
        error:''
     }, //['ServiceID','msg', 'MenuArray','error'],
  data: function () {
      
    return {
 
        }
    },
    components: { 
              Card,
            CardBody,
            TileNote,
            TileCard           
        },
    mounted: function () {
    this.$nextTick(function () {  
    })
    },
    created: function() { 
        //this.$emit('update:layout', LoginLayout);
        //////console.log('at Dental Main home')
        //this.menuitems = this.$store.getters.GetMainMenu; 
    },
    computed:{
        ...mapGetters({
                GetMessage: 'GetMessage',
                ShowLoginMsg: 'ShowLoginMsg'
            }),
        errorMsg: {
           get(){
             return this.GetMessage
           },
           set(newName){
             return newName
           } 
        }, 
        ...mapGetters({
                 
                ShowLoginMsg: 'ShowLoginMsg'
            }),
        ShowMsg: {
           get(){
             return this.ShowLoginMsg
           },
           set(val){
             return val
           } 
        },
    },
    watch: {
    ShowMsg: function (val) {
        //////console.log (val)
        if(val)
        {
            //this.showMsg1("Seesion","","Con")
        }
        },
    },
    methods: {
    HideMsg: function(val){
        this.$store.dispatch('ResetLoginMSg');
        this.$bvModal.hide('modal-sm');
        },
    showMsg1(msg,data,Title) {
        this.boxTwo = ''
        this.$bvModal.msgBoxOk(msg, {
        title: Title,
        size: 'md',
        buttonSize: 'md',
        okVariant: 'primary',          
        okTitle: 'Close', 
        footerClass: 'p-2',
        hideHeaderClose: true,
        hideHeaderCancel: true,
        centered: true, 
        }); 
      }, 
    },
}
</script>
<style scoped>

</style>

